// client/src/index.js (Updated)
import reportWebVitals from './reportWebVitals';
import './utils/axiosConfig'; // Apply global axios configuration
import React from 'react';
import ReactDOM from 'react-dom/client';
import { store } from './store';
import { Provider } from 'react-redux';
import { ContextProvider } from './context/SocketContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* Wrap the App in the Provider */}
        <Provider store={store}>
            <ContextProvider> {/* Wrapped App with ContextProvider */}
                <ThemeProvider>
                    <ErrorBoundary>
                        <App />
                    </ErrorBoundary>
                </ThemeProvider>
            </ContextProvider>
        </Provider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
